import DOMPurify from 'dompurify';

// Keep links opened from sanitized content safe: force noopener/noreferrer and
// only allow them to open in a new tab. Hardened against reverse tabnabbing.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node instanceof Element && node.tagName === 'A' && node.hasAttribute('href')) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export function sanitize(input: string): string {
    return DOMPurify.sanitize(input, {
        // Allow the attributes our renderer relies on (code-block metadata,
        // copy-button state, link targets) while DOMPurify strips event
        // handlers (on*), <script>, javascript: URLs, and other XSS vectors.
        ADD_ATTR: ['target', 'data-language', 'data-copy-state', 'data-copy-label', 'dir'],
        // Strip inline `style` to block CSS-based attacks (full-screen
        // `position: fixed` overlays / clickjacking) injected via message HTML.
        // Our rendered content styles itself via classes, not inline styles.
        FORBID_ATTR: ['style'],
        // Disallow injected form/interactive UI that could be used for phishing
        // (the chat renderer never legitimately emits these).
        FORBID_TAGS: ['style', 'form', 'input', 'select', 'option', 'textarea']
    });
}
